"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PersonActionSearchResult = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-void */
var react_1 = __importDefault(require("react"));
var features_1 = require("@hiyllo/omni-common/src/types/navigation/features");
var common_1 = require("../common");
var use_on_click_index_1 = require("@hiyllo/ux/use-on-click-index");
var keyboard_hint_1 = require("../keyboard-hint");
var omni_images_1 = require("@hiyllo/omni-images");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var omni_chat_1 = require("@hiyllo/omni-chat");
var platform_1 = require("@hiyllo/ux/platform");
exports.PersonActionSearchResult = react_1["default"].memo(function PersonSearchResult(props) {
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    var navigate = (0, omni_continuity_1.useNavigate)();
    var createChat = (0, omni_chat_1.useCreateChatWithIndividual)();
    var onClick = react_1["default"].useCallback(function () {
        if (props.result.action === 'message') {
            void createChat
                .call({ userId: props.result.user.id })
                .then(function (_a) {
                var chatUUID = _a.chatUUID;
                navigate({
                    feature: features_1.Features.chat,
                    params: { chatUUID: chatUUID }
                });
            })
                .then(props.onClose);
        }
        // if (props.result.action === 'call') {
        //   void createQuickCallMutation
        //     .call({withUserId: props.result.user.id})
        //     .then(({meetingUUID, password}) => {
        //       navigate({
        //         feature: Features.meet,
        //         params: {
        //           view: 'meeting',
        //           meetingUUID,
        //           password,
        //         },
        //       });
        //     })
        //     .then(props.onClose);
        // }
        if (props.result.action === 'view-tasks') {
            navigate({
                feature: features_1.Features.tasks,
                params: {
                    view: 'user-tasks',
                    userId: props.result.user.id
                }
            });
            props.onClose();
        }
        if (props.result.action === 'view-calendar') {
            navigate({
                feature: features_1.Features.calendar,
                params: {
                    view: 'calendar-of',
                    userId: props.result.user.id
                }
            });
            props.onClose();
        }
    }, [createChat, navigate, props]);
    (0, use_on_click_index_1.useOnClickIndex)(onClick, props.index);
    return ((0, jsx_runtime_1.jsxs)(common_1.SearchResultContainer, __assign({ onPress: onClick }, { children: [(0, jsx_runtime_1.jsx)(keyboard_hint_1.SearchResultKeyboardHint, { showTabHint: true, value: (props.index + 1).toString() }), (0, jsx_runtime_1.jsx)(omni_images_1.UserImage, { userId: props.result.user.id, width: 20 }), (0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: props.result.action === 'view-calendar'
                    ? pro_light_svg_icons_1.faCalendarAlt
                    : props.result.action === 'view-tasks'
                        ? pro_light_svg_icons_1.faSquareKanban
                        : props.result.action === 'message'
                            ? pro_light_svg_icons_1.faComment
                            : props.result.action === 'call'
                                ? pro_light_svg_icons_1.faPhoneAlt
                                : props.result.action === 'back'
                                    ? pro_light_svg_icons_1.faArrowLeft
                                    : pro_light_svg_icons_1.faQuestion }), props.result.action === 'view-calendar'
                ? 'View Calendar of'
                : props.result.action === 'view-tasks'
                    ? 'View Tasks for '
                    : props.result.action === 'message'
                        ? 'Message '
                        : props.result.action === 'call'
                            ? 'Call '
                            : props.result.action === 'back'
                                ? null
                                : null, (0, jsx_runtime_1.jsx)(common_1.SearchResultText, { children: props.result.user.name }), (0, jsx_runtime_1.jsx)(common_1.SearchResultAppLabel, { icon: pro_light_svg_icons_1.faUserCircle, title: "Person" })] })));
});
